import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Button from 'common/components/elements/buttons/primary';
import Header from 'common/components/modules/story-player/header';
import Bottom from 'common/components/modules/story-player/bottom';
import { BlurhashCanvas } from "react-blurhash";

const LockedContent = ({
   title,
   date,
   showTimeLeft,
   timeLeft,
   timeSector,
   commentsCount,
   hasAccess,
   isLiked,
   onClose,
   onClickLockedButton,
   onClickComment,
   onClickLike,
   onClickShare,
   isAuthUsers,
   hideAfterMinutes,
   blurhash,
   isDemoMode,
   showComments,
}) => {
   return (
      <div className='w-full h-full bg-secondary relative leading-none flex flex-col items-center justify-between'>
         {/* TODO temporary solution (this only for show) */}
         <div
            className='absolute w-full h-full'
         >
            <BlurhashCanvas
               hash={ !!blurhash ? blurhash : 'LEHV6nWB2yk8pyo0adR*.7kCMdnj' }
               punch={ 1 }
               className='rounded-lg w-full h-full'
            />
         </div>
         <Header
            showTimeLeft={ showTimeLeft }
            handleClose={ onClose }
            title={ title }
            timeLeft={ timeLeft }
            date={ date }
            timeSector={ timeSector }
            hideAfterMinutes={ hideAfterMinutes }
         />
         <div className='flex flex-col justify-center items-center z-10'>
            <div
               className='inline-flex shadow dark:shadow-dark'
            >
               <Button
                  text='Join'
                  borderRadius='large'
                  onClick={ onClickLockedButton }
                  fontWeight='medium'
                  primaryColor
               />
            </div>
            {
               isAuthUsers && (
                  <div className='z-10 mt-3'>
                     <span className='font-medium text-major-dark tracking-wide'>
                        And get unlimited access
                     </span>
                  </div>
               )
            }
         </div>
         <div
            className='absolute w-full h-full'
            style={ {
               background: 'linear-gradient(180deg,rgba(0,0,0,.3),transparent 25.97%,transparent 80.32%,rgba(0,0,0,.4))',
            } }
         />
         <Bottom
            hasAccess={ hasAccess }
            commentsCount={ commentsCount }
            isLiked={ isLiked }
            onClickComment={ onClickComment }
            onClickLike={ onClickLike }
            onClickShare={ onClickShare }
            isAuthUsers={ isAuthUsers }
            isDemoMode={ isDemoMode }
            showComments={ showComments }
         />
      </div>
   );
};

LockedContent.propTypes = {
   title: PropTypes.string,
   date: PropTypes.string,
   timeLeft: PropTypes.string,
   timeSector: PropTypes.number,
   commentsCount: PropTypes.number,
   showTimeLeft: PropTypes.bool,
   hasAccess: PropTypes.bool,
   isLiked: PropTypes.bool,
   onClose: PropTypes.func,
   onClickLockedButton: PropTypes.func,
   onClickComment: PropTypes.func,
   onClickLike: PropTypes.func,
   onClickShare: PropTypes.func,
   isAuthUsers: PropTypes.bool,
   hideAfterMinutes: PropTypes.number,
   blurhash: PropTypes.string,
   isDemoMode: PropTypes.bool,
   showComments: PropTypes.bool,
};

export default memo(LockedContent);
